/*
 * Solder Selection Tool — 1:1 behavioral clone of the sd-dectree component on
 * kappalloy.com (extracted 2026-08-24). The original rewrites data-toggle
 * targets at runtime; this version keeps the same observable behavior with a
 * history stack, so Go Back always returns to the panel the visitor came from
 * (including the Household/Automotive/Marine branches that reuse the plumbing
 * and electric panels).
 */
(() => {
  const initSelectionTool = (root) => {
    if (root.dataset.kawSstInit) return;
    root.dataset.kawSstInit = 'true';

    const controller = new AbortController();
    const { signal } = controller;
    const stages = [...root.querySelectorAll('[data-kaw-stage]')];
    const live = root.querySelector('[data-kaw-live]');
    const history = [{ stage: 'start', panel: 'start' }];
    let pendingOutcome = null;

    const show = (state, focus = true) => {
      root.querySelectorAll('[data-kaw-panel]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.kawPanel === state.panel);
      });
      const stage = stages.find((candidate) => candidate.dataset.kawStage === state.stage);
      const header = stage.querySelector('.kaw-selection-tool__header');
      if (live) live.textContent = `Step ${header.dataset.kawStep} of 6: ${header.textContent.trim()}`;
      // the original never scrolls on navigation (its data-scroll attributes are unread)
      if (focus) header.focus({ preventScroll: true });
    };

    const goto = (stage, panel) => {
      history.push({ stage, panel });
      show(history[history.length - 1]);
    };

    const back = () => {
      if (history.length > 1) history.pop();
      show(history[history.length - 1]);
    };

    root.querySelectorAll('[data-kaw-metal]').forEach((panel) => {
      const config = JSON.parse(panel.dataset.kawMetal);
      const radios = [...panel.querySelectorAll('input[type="radio"]')];
      const byOrig = (id) => radios.find((radio) => radio.dataset.kawOrig === id);
      const byClass = (name) => radios.filter((radio) => (radio.dataset.kawClass || '').split(' ').includes(name));
      const nextButton = panel.querySelector('[data-kaw-metal-next]');
      const names = [...new Set(radios.map((radio) => radio.name))];

      const currentSum = () => names.reduce((total, name) => {
        const checked = panel.querySelector(`input[name="${CSS.escape(name)}"]:checked`);
        return checked ? total + Number(checked.value) : NaN;
      }, 0);

      const refresh = () => {
        nextButton.hidden = !config.outcomes[String(currentSum())];
      };

      radios.forEach((radio) => {
        // the original binds its enable/disable/sync rules to click (not change)
        radio.addEventListener('click', () => {
          (config.rules || []).forEach((rule) => {
            const matches = (rule.on && radio.dataset.kawOrig === rule.on)
              || (rule.onClass && (radio.dataset.kawClass || '').split(' ').includes(rule.onClass));
            if (!matches) return;
            (rule.disable || []).forEach((id) => { const target = byOrig(id); if (target) target.disabled = true; });
            (rule.enable || []).forEach((id) => { const target = byOrig(id); if (target) target.disabled = false; });
            (rule.check || []).forEach((name) => byClass(name).forEach((target) => { target.checked = true; }));
          });
          refresh();
        }, { signal });
        radio.addEventListener('change', refresh, { signal });
      });

      nextButton.addEventListener('click', () => {
        const target = config.outcomes[String(currentSum())];
        if (!target) return;
        pendingOutcome = { stage: 'main-cats', panel: target };
        goto('select-atr', 'atr-inside');
      }, { signal });
    });

    root.addEventListener('click', (event) => {
      const nav = event.target.closest('[data-kaw-goto]');
      if (nav) {
        const [stage, panel] = nav.dataset.kawGoto.split('/');
        goto(stage, panel || stage);
        return;
      }
      if (event.target.closest('[data-kaw-attrs-next]')) {
        if (pendingOutcome) goto(pendingOutcome.stage, pendingOutcome.panel);
        return;
      }
      if (event.target.closest('[data-kaw-sst-back]')) {
        back();
        return;
      }
      const modalTrigger = event.target.closest('[data-kaw-modal]');
      if (modalTrigger) {
        const dialog = root.querySelector(`[data-kaw-modal-id="${modalTrigger.dataset.kawModal}"]`);
        if (dialog) dialog.showModal();
        return;
      }
      if (event.target.closest('[data-kaw-modal-close]')) {
        const dialog = event.target.closest('dialog');
        if (dialog) dialog.close();
      }
    }, { signal });

    root.querySelectorAll('dialog[data-kaw-modal-id]').forEach((dialog) => {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      }, { signal });
    });

    show(history[0], false);

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(root)) controller.abort();
    }, { signal });
  };

  const initAll = () => document.querySelectorAll('[data-kaw-sst]').forEach(initSelectionTool);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
